import { IUser } from '../types/user.type';
import api from './api';

export const fetchUserDetails = async (): Promise<IUser> => {
  const response = await api.get<IUser>('/auth/users');
  return response.data;
};
